import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import ButtonCustom from "../../components/Buttons/ButtomCustom";
import {
  cleanMessageLogo,
  getLogo,
  getLogoHistory,
  loadEmptyLogo,
  saveLogo,
} from "../../store/actions";
import { useEffect, useState } from "react";
import useQueryParams from "../../customHooks/useQueryParams";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import { setValuesHookForm } from "../../helpers/load_object_hook_form";
import { fieldsMessage } from "../../helpers/utils/fieldsMessage";
import "../../assets/scss/_commomAdminPages.scss";
import useImportFile from "../../customHooks/useImportFile";
import { useNavigate } from "react-router-dom";
import ActionButtons from "../../components/ActionButtons/ActionButtons";
import { useContextActions } from "../../customHooks/useContextActions";
import useAlert from "../../customHooks/useAlert";

const LogoDetail = ({
  saveLogoRequest,
  getLogoRequest,
  cleanMessageLogo,
  isLogoSave,
  logo,
  loadEmptyLogo,
  loadingLogo,
  getLogoHistoryRequest,
  messageLogo,
  errorLoadingLogo, 
  errorLoadingLogoHistory,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      active: true,
    }
  });

  const alertModal = withReactContent(Swal);
  const { confirmAlert } = useAlert();

  const [img64, setImg64] = useState("");
  const query = useQueryParams();
  const id = query.get("id");
  const idHistory = query.get("idHistory");
  const importFile = useImportFile();
  const navigate = useNavigate();

  async function handleSave(values) {
    const isEdit = id !== null;
    const baseBody = {
      title: values.title,
      active: values.active,
      description: values.description,
      base64Image: img64,
    };
    const body = isEdit ? { ...baseBody, id } : baseBody;

    if(isEdit) {
      const result = await confirmAlert("Attention! All documents associated with this Logo will be updated to Draft status. Do you want to continue?")

        if(!result.isConfirmed) return;
    }

    await saveLogoRequest({ 
      body, 
      type: isEdit ? "PUT" : "POST" 
    });    
  };
  const handleBack = () => {
    loadEmptyLogo();
    navigate("/logos");
  };
  const handleInputImg = (values) => {
    const file = values.files[0];
    if (!file) return;

    importFile(file).then((res) => {
      setImg64(res);
    });
  };

  const actions = useContextActions({
    context: "logo",
    screen: "detail",
  })
  const editableWithSave = actions.some(e => e === 'save');

  useEffect(() => {
    if (id !== null) {
      getLogoRequest({ logoId: id });
    } else if (idHistory !== null) {
      getLogoHistoryRequest({ logoHistoryId: idHistory });
    }

    return () => {
      cleanMessageLogo();
    };
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (isLogoSave !== null) {
      alertModal
        .fire({
          title:
            isLogoSave === true
              ? `Logo ${id === null ? "created" : "updated"} successfully`
              : `${
                  messageLogo !== null
                    ? messageLogo
                    : "Something wrong, try again later."
                }`,
          icon: isLogoSave === true ? "success" : "error",
          showConfirmButton: false,
          timer: isLogoSave === true ? 2000 : undefined,
          showCloseButton: !isLogoSave,
          timerProgressBar: isLogoSave === true ? true : false,
        })
        .then((result) => {
          if (result.dismiss) {
            cleanMessageLogo();
            if (isLogoSave) navigate("/logos");
          }
        });
    }

    // eslint-disable-next-line
  }, [isLogoSave]);
  useEffect(() => {
    if (errorLoadingLogo !== null) {
      alertModal
        .fire({
          title: "Something wrong, try again later.",
          icon: "error",
          showConfirmButton: false,
          showCloseButton: true,
          allowOutsideClick: false,
          //timer: 2000,
          //timerProgressBar: true,
        }).then((result) => {
          if (errorLoadingLogo) {
            if (result.dismiss) {
              cleanMessageLogo();
              loadEmptyLogo();
              navigate("/logos");
            }
          }
          if (result.dismiss) {
            cleanMessageLogo();
            loadEmptyLogo();
          }
        })
    }

    // eslint-disable-next-line
  }, [errorLoadingLogo]);
  useEffect(() => {
    if (errorLoadingLogoHistory !== null) {
      alertModal
        .fire({
          title: "Something wrong, try again later.",
          icon: "error",
          showConfirmButton: false,
          showCloseButton: true,
          allowOutsideClick: false,
          //timer: 2000,
          //timerProgressBar: true,
        }).then((result) => {
          if (errorLoadingLogoHistory) {
            if (result.dismiss) {
              cleanMessageLogo();
              loadEmptyLogo();
              navigate("/logos");
            }
          }
          if (result.dismiss) {
            cleanMessageLogo();
            loadEmptyLogo();
          }
        })
    }

    // eslint-disable-next-line
  }, [errorLoadingLogoHistory]);
  useEffect(() => {
  if (!logo) return;

  setValuesHookForm(logo, setValue);
  setImg64(logo.base64Image);
  setValue("active", logo.active ?? true);

  // eslint-disable-next-line
  }, [logo]);

  return (
    <div className="page-content">
      <Helmet>
        <title>Logo</title>
      </Helmet>
      <div></div>
      <Container fluid>
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <div>
                  <Row className="my-2">
                    {loadingLogo ? (
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ height: "400px", width: "100%" }}
                      >
                        <Spinner
                          color="primary"
                          style={{ height: "5rem", width: "5rem" }}
                        />
                      </div>
                    ) : (
                      <>
                        <form onSubmit={handleSubmit(handleSave)}>
                          <div className="d-flex justify-content-between my-2">
                            <h2>
                              {id === null
                                ? idHistory === null
                                  ? "CREATE"
                                  : "VIEW"
                                : "EDIT"}{" "}
                              LOGO
                            </h2>
                            <div className="d-flex gap-2 mb-4">
                              <ButtonCustom
                                type="cancel"
                                onClick={() => handleBack()}
                              />
                              <ActionButtons 
                                actions={actions}
                                handlers={{
                                  save: handleSubmit(handleSave),
                                }}  
                              />
                            </div>
                          </div>
                          <Row>
                            <Col md="4">
                              <FormGroup className="mb-3">
                                <Label
                                  htmlFor="name"
                                  className="label-detail-form"
                                >
                                  Title
                                </Label>
                                <input
                                  className="form-control"
                                  id="title"
                                  type="text"
                                  disabled={(idHistory !== null) || (!editableWithSave)}
																	style={(idHistory !== null) || (!editableWithSave) ? {color: "#00000060"} : {}}
                                  {...register("title", {
                                    required:
                                      fieldsMessage.required("Logo title"),
                                    validate: (value) =>
                                      value.trim() !== "" ||
                                      fieldsMessage.required("Logo title"),
                                    maxLength: {
                                      value: 100,
                                      message: fieldsMessage.maxLength(
                                        "Logo title",
                                        100
                                      ),
                                    },
                                  })}
                                />
                                <p className="error-form">
                                  {errors.title?.message}
                                </p>
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup className="mb-3">
                                <Label
                                  htmlFor="createUser"
                                  className="label-detail-form"
                                >
                                  Created By
                                </Label>
                                <input
                                  className="form-control"
                                  id="createUser"
                                  {...register("createUser")}
                                  disabled
                                  style={{ color: '#00000060'}}
                                />
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup className="mb-3">
                                <Label
                                  id="createDate"
                                  className="label-detail-form"
                                >
                                  Creation Date
                                </Label>
                                <input
                                  className="form-control"
                                  name="createDate"
                                  {...register("createDate")}
                                  disabled
                                  style={{ color: '#00000060'}}
                                />
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup className="mb-3">
                                <Label
                                  id="updateUser"
                                  className="label-detail-form"
                                >
                                  Updated By
                                </Label>
                                <input
                                  className="form-control"
                                  name="updateUser"
                                  {...register("updateUser")}
                                  disabled
                                  style={{ color: '#00000060'}}
                                />
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup className="mb-3">
                                <Label
                                  id="updateDate"
                                  className="label-detail-form"
                                >
                                  Update Date
                                </Label>
                                <input
                                  className="form-control"
                                  name="updateDate"
                                  {...register("updateDate")}
                                  disabled
                                  style={{ color: '#00000060'}}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row className="my-2 mb-4">
                            <Col md="4">
                              <Row>
                                <FormGroup className="mb-3">
                                  <Label
                                    id="file"
                                    className="label-detail-form"
                                  >
                                    File Upload
                                  </Label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    name="file"
                                    disabled={(idHistory !== null) || (!editableWithSave)}
                                    {...register("file", {
                                      onChange: (e) => handleInputImg(e.target),
                                      validate: {
                                        typeFile: (value) => {
                                          if (!value || value.length === 0)
                                            return true;

                                          const ext = value[0].name
                                            .split(".")[1]
                                            .toLowerCase();
                                          const extImg = ["jpg", "png", "jpeg"];
                                          return (
                                            extImg.includes(ext) ||
                                            fieldsMessage.typeFile(
                                              "File Upload",
                                              extImg
                                            )
                                          );
                                        },
                                        sizeFile: (value) => {
                                          if (!value || value.length === 0)
                                            return true;
                                          const size = value[0].size;
                                          const maxSize = 5 * 1024 * 1024;

                                          return (
                                            size <= maxSize ||
                                            fieldsMessage.sizeFile(
                                              "File Upload",
                                              5
                                            )
                                          );
                                        },
                                        requiredImg: (value) => {
                                          if (img64 !== "") return true;
                                          if (value.length > 0) return true;

                                          return (
                                            !value ||
                                            fieldsMessage.required(
                                              "File upload"
                                            )
                                          );
                                        },
                                      },
                                    })}
                                  />
                                  <p className="error-form">
                                    {errors.file?.message}
                                  </p>
                                </FormGroup>
                                <div className="flex-fill mb-3">
                                  {img64 !== "" ? (
                                    <img
                                      height={300}
                                      src={img64}
                                      alt={"Logo"}
                                    />
                                  ) : null}
                                </div>
                              </Row>
                            </Col>

                            <Col md="6">
                              <FormGroup className="mb-3">
                                <Label
                                  id="description"
                                  className="label-detail-form"
                                >
                                  Description
                                </Label>
                                <textarea
                                  className="form-control"
                                  name="description"
                                  rows={1}
                                  disabled={(idHistory !== null) || (!editableWithSave)}
                                  style={(idHistory !== null) || (!editableWithSave) ? {color: "#00000060"} : {}}
                                  {...register("description")}
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label htmlFor="active" className="label-check">
                                  <input
                                    id="active"
                                    type="checkbox"
                                    className="form-check-input"
                                    disabled={(idHistory !== null) || (!editableWithSave)}
                                    {...register("active")}
                                  />
                                  Active Status
                                </label>
                              </FormGroup>
                            </Col>
                          </Row>
                        </form>
                      </>
                    )}
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = ({
  LogoReducer: { loadingLogo, logo, messageLogo, isLogoSave, logoHistory,	errorLoadingLogo, errorLoadingLogoHistory, },
}) => ({
  loadingLogo,
  logo,
  messageLogo,
  isLogoSave,
  logoHistory,
  errorLoadingLogo,
	errorLoadingLogoHistory,
});

const mapDispatchToProps = {
  saveLogoRequest: saveLogo.request,
  getLogoRequest: getLogo.request,
  loadEmptyLogo,
  cleanMessageLogo,
  getLogoHistoryRequest: getLogoHistory.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoDetail);
